import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BusinessService } from '../models/business-service.model';
import { AuthEventType } from '../../auth/models/auth-event.model';
import { AuthService } from '../../auth/auth/auth.service';
import { UserService } from '../../shared/user/user.service';
import { environment } from '../../../environments/environment';
var BusinessFeesService = /** @class */ (function () {
    function BusinessFeesService(_http, _auth, _userService, _errorHandler) {
        var _this = this;
        this._http = _http;
        this._auth = _auth;
        this._userService = _userService;
        this._errorHandler = _errorHandler;
        this._auth.authStream.subscribe(function (e) { return _this._onAuthEvent(e); });
    }
    BusinessFeesService.prototype._onAuthEvent = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!e) {
                            return [2 /*return*/];
                        }
                        _a = e.type;
                        switch (_a) {
                            case AuthEventType.SignIn: return [3 /*break*/, 1];
                            case AuthEventType.InvalidSignIn: return [3 /*break*/, 3];
                            case AuthEventType.SignOut: return [3 /*break*/, 3];
                        }
                        return [3 /*break*/, 4];
                    case 1:
                        _b = this;
                        return [4 /*yield*/, this._userService.getUserInfo()];
                    case 2:
                        _b.userInfo = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.userInfo = null;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Method creates a new BusinessService in the API Server via a post request with the business id and a business service object.
    * @param businessId {number} used to identify the business
    * @param fee {BusinessService} business service object
    * @returns {Promise<BusinessService>} API Server will respond with a new BusinessService OBJ.
    */
    BusinessFeesService.prototype.createBusinessService = function (businessId, fee) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR, URL, BODY, RESPONSE, FEE, ERROR, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._auth.authenticated || !this._auth.token || !this._auth.endUser) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        URL = environment.airportsApiUrl + "/business/" + businessId + "/service/";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        BODY = this._getFeeJSON(fee);
                        return [4 /*yield*/, this._http.post(URL, BODY).toPromise()];
                    case 2:
                        RESPONSE = _a.sent();
                        FEE = BusinessService.parse(RESPONSE);
                        if (!FEE) {
                            ERROR = new Error('API did not return valid business service object');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        else {
                            return [2 /*return*/, FEE];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this._errorHandler.handleError(e_1);
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Sends put request to api server to update a given businessService.
    * Method updates the API Server with data from the json object with the service being passed in.
    * @param businessId {number} businessId
    * @param serviceId {number} the id of the BusinessService that will be updated
    * @param fee {BusinessService} content to be updated.
    * @returns {Promise<BusinessService>} API Server will respond with updated BusinessService OBJ.
    */
    BusinessFeesService.prototype.updateBusinessService = function (businessId, serviceId, fee) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR, URL, BODY, RESPONSE, FEE, ERROR, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._auth.authenticated || !this._auth.token || !this._auth.endUser) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        URL = environment.airportsApiUrl + "/business/" + businessId + "/service/" + serviceId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        BODY = this._getFeeJSON(fee);
                        return [4 /*yield*/, this._http.put(URL, BODY).toPromise()];
                    case 2:
                        RESPONSE = _a.sent();
                        FEE = BusinessService.parse(RESPONSE);
                        if (!FEE) {
                            ERROR = new Error('API did not return valid business service object');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        else {
                            return [2 /*return*/, FEE];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        this._errorHandler.handleError(e_2);
                        throw e_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Method to call API to delete a business service from a business
    * @param businessId {number} the business to remove the service from.
    * @param serviceId {number} the specific business service to be deleted.
    * @returns {Promise<boolean>} Returns boolean
    */
    BusinessFeesService.prototype.deleteBusinessService = function (businessId, serviceId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR, URL, RESPONSE, e_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._auth.authenticated || !this._auth.token || !this._auth.endUser) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        URL = environment.airportsApiUrl + "/business/" + businessId + "/service/" + serviceId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.delete(URL).toPromise()];
                    case 2:
                        RESPONSE = _a.sent();
                        return [2 /*return*/, true];
                    case 3:
                        e_3 = _a.sent();
                        this._errorHandler.handleError(e_3);
                        throw false;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * converts business fee to json obj
     * @param {BusinessService} fee
     * @return {any}
     * @private
     */
    BusinessFeesService.prototype._getFeeJSON = function (fee) {
        return {
            description: fee.description,
            fee: fee.fee,
            feeBasis: BusinessService.formatFeeBasis(fee.feeBasis),
            serviceNote: fee.serviceNote,
            aircraftType: fee.aircraftType,
            waiver: fee.waiver || false,
            waiverFuelQty: fee.waiverFuelQty
        };
    };
    /**
     * Gets all the fee types from the API
     * @returns {Promise<Array<string>>} FeeTypes
     */
    BusinessFeesService.prototype.getFeeTypes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var URL, feeTypes, RESPONSE, ERROR, i, e_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        URL = environment.airportsApiUrl + "/lookups?category=FeeTypes";
                        feeTypes = new Array();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.get(URL).toPromise()];
                    case 2:
                        RESPONSE = _a.sent();
                        if (!RESPONSE) {
                            ERROR = new Error('API did not return valid business admin notes object');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        else {
                            for (i = 0; i < RESPONSE.length; i++) {
                                feeTypes.push(RESPONSE[i].lookup);
                            }
                            return [2 /*return*/, feeTypes];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_4 = _a.sent();
                        this._errorHandler.handleError(e_4);
                        throw e_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets all the fee types from the API
     * @returns {Promise<Array<string>>} FeeTypes
     */
    BusinessFeesService.prototype.getAircraftTypes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var URL, feeTypes, RESPONSE, ERROR, i, e_5;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        URL = environment.airportsApiUrl + "/lookups?category=AircraftTypes";
                        feeTypes = new Array();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.get(URL).toPromise()];
                    case 2:
                        RESPONSE = _a.sent();
                        if (!RESPONSE) {
                            ERROR = new Error('API did not return valid business admin notes object');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        else {
                            for (i = 0; i < RESPONSE.length; i++) {
                                feeTypes.push(RESPONSE[i].lookup);
                            }
                            return [2 /*return*/, feeTypes];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_5 = _a.sent();
                        this._errorHandler.handleError(e_5);
                        throw e_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return BusinessFeesService;
}());
export { BusinessFeesService };
